"use client";

import { useEffect, useState } from "react";
import { fetchCourseLearnerState } from "../lib/courseLearnerApi";

/**
 * Hero-area join flow (challenges-style): request → admin accept/refuse → unlock when accepted.
 * Hidden when course does not require enrollment in WordPress.
 */
export default function CourseJoinBlock({ courseId }) {
    const [learner, setLearner] = useState(null);

    const load = () => {
        void fetchCourseLearnerState(courseId, []).then(setLearner);
    };

    useEffect(() => {
        load();
    }, [courseId]);

    useEffect(() => {
        const onReload = () => load();
        if (typeof window !== "undefined") {
            window.addEventListener("figmawya-course-learner-reload", onReload);
            return () => window.removeEventListener("figmawya-course-learner-reload", onReload);
        }
    }, [courseId]);

    if (!learner?.requiresEnrollment) {
        return null;
    }

    const access = learner.enrollmentAccess ?? "none";

    if (access === "accepted") {
        return (
            <div className="alert alert-success border-0 shadow-sm py-2 px-3 small mb-0 mt-3" role="status" dir="rtl">
                <i className="bi bi-check-circle-fill me-2" aria-hidden />
                تم قبول انضمامك — يمكنك متابعة الدروس والاختبارات أدناه.
            </div>
        );
    }

    /* login_required & needs_apply: primary CTA lives in CourseJoinNavButtons (hero/sidebar) */

    if (access === "login_required" || access === "needs_apply") {
        return null;
    }

    if (access === "pending") {
        return (
            <div className="alert alert-info border-0 shadow-sm mt-3 mb-0" role="status" dir="rtl">
                طلبك قيد المراجعة. عند الموافقة ستُفتح لك الدروس تلقائياً.
            </div>
        );
    }

    if (access === "refused") {
        return (
            <div className="alert alert-secondary border-0 shadow-sm mt-3 mb-0" role="status" dir="rtl">
                لم يتم قبول طلب الانضمام لهذه الدورة.
            </div>
        );
    }

    return null;
}
